import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useLang } from "../i18n";
import { scrollToId } from "../lib";
import { Logo } from "./Logo";

export const Nav = () => {
  const { t, lang, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const go = (e, hash) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(hash);
  };

  const links = [
    [t.nav.ciclo, "#ciclo"],
    [t.nav.paraQuem, "#para-quem"],
    [t.nav.atuar, "#consultoria"],
    [t.nav.governanca, "#governanca"],
    [t.nav.pilares, "#pilares"],
  ];

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "border-white/10 bg-black/60 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <Logo />
        <div className="hidden items-center gap-8 md:flex">
          {links.map(([label, hash]) => (
            <a
              key={hash}
              data-testid={`nav-link-${hash.slice(1)}`}
              href={hash}
              onClick={(e) => go(e, hash)}
              className="text-sm text-white/70 transition-colors hover:text-white"
            >
              {label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center rounded-full border border-white/15 p-0.5 font-mono text-[11px] font-semibold">
            <button
              data-testid="lang-toggle-pt"
              onClick={() => setLang("pt")}
              aria-pressed={lang === "pt"}
              className={`rounded-full px-2.5 py-1 transition-colors ${lang === "pt" ? "bg-volt text-black" : "text-white/60 hover:text-white"}`}
            >
              PT
            </button>
            <button
              data-testid="lang-toggle-en"
              onClick={() => setLang("en")}
              aria-pressed={lang === "en"}
              className={`rounded-full px-2.5 py-1 transition-colors ${lang === "en" ? "bg-volt text-black" : "text-white/60 hover:text-white"}`}
            >
              EN
            </button>
          </div>
          <a
            data-testid="nav-cta"
            href="#contato"
            onClick={(e) => go(e, "#contato")}
            className="hidden rounded-full bg-volt px-5 py-2.5 font-display text-sm font-bold text-black transition-shadow hover:shadow-[0_0_30px_-6px_rgba(0,229,255,0.8)] sm:inline-flex"
          >
            {t.nav.cta}
          </a>
          <button
            data-testid="nav-menu-button"
            aria-label={t.nav.menu}
            onClick={() => setOpen(!open)}
            className="rounded-full border border-white/15 p-2.5 text-white md:hidden"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="border-t border-white/10 bg-black/90 px-5 py-6 backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-5">
            {links.map(([label, hash]) => (
              <a
                key={hash}
                href={hash}
                onClick={(e) => go(e, hash)}
                className="font-display text-lg font-bold text-white/85"
              >
                {label}
              </a>
            ))}
            <a
              data-testid="nav-mobile-cta"
              href="#contato"
              onClick={(e) => go(e, "#contato")}
              className="mt-2 inline-flex w-fit rounded-full bg-volt px-5 py-2.5 font-display text-sm font-bold text-black"
            >
              {t.nav.cta}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
